import React from "react";

import styles from "./RadioButton.module.scss";

const RadioButton = ({
  onChange,
  checked,
  disabled,
  value,
  name
}: {
  onChange: (value: string) => void;
  checked: boolean;
  value: string;
  name: string;
  disabled?: boolean;
}) => {
  return (
    <label className={styles.checkbox}>
      <input
        onChange={(event) => onChange(event.target.value)}
        checked={checked}
        disabled={disabled}
        type="radio"
        name={name}
        value={value}
        className={styles.checkbox__input}
      />
      <span className={styles.checkbox__label}></span>
    </label>
  );
};

export default RadioButton;
